import client from 'lib/apiClient';
const BASEURL = 'API/1_0/notifications.php';

export const getNotifications = (query) => {
  return client.get(BASEURL, { params: query });
};

export const updateNotification = (data) => {
  return client.post(BASEURL, data);
};

export const getConvNotifications = (conv_hash, signal) => {
  return client.get(BASEURL, { params: { conv_hash }, signal });
};
